import { render, staticRenderFns } from "./GroupRight.vue?vue&type=template&id=43b36324&"
import script from "./GroupRight.vue?vue&type=script&lang=js&"
export * from "./GroupRight.vue?vue&type=script&lang=js&"
import style0 from "./GroupRight.vue?vue&type=style&index=0&id=43b36324&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports